var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c8605e",
    d: "M21.107,89.505c4.674-35.931,33.118-64.375,69.049-69.049V0.651C43.356,5.514,6.165,42.706,1.302,89.505 H21.107z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#36556f",
    d: "M111.031,20.455c35.931,4.674,64.375,33.118,69.05,69.05h19.805c-4.862-46.8-42.054-83.992-88.854-88.854 V20.455z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8605e",
    d: "M180.081,110.38c-4.675,35.932-33.119,64.376-69.05,69.05v19.805c46.801-4.861,83.992-42.053,88.854-88.854 H180.081z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#36556f",
    d: "M90.156,179.43c-35.931-4.675-64.375-33.119-69.049-69.05H1.302c4.862,46.801,42.054,83.992,88.854,88.854 V179.43z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.b2a46a984a3feb05baf2d6f9489260f4.svg";
export { ForwardRef as ReactComponent };